import classNames from 'classnames/bind';
import { ReactElement } from 'react';

import styles from './WeightIcon.module.scss';

const cx = classNames.bind(styles);

interface WeightIconProps {
  weighting: string;
}

export enum WeightingType {
  Buy = 'Buy',
  Hold = 'Hold',
  Marketperform = 'Marketperform',
  NoRecommendation = 'NoRecommendation',
  Outperform = 'Outperform',
  Sell = 'Sell',
  Underperform = 'Underperform',
}

export enum WeightingTitleType {
  buy = 'BUY',
  hold = 'HOLD',
  marketperform = 'M/P',
  norecommendation = 'N/R',
  outperform = 'O/P',
  sell = 'SELL',
  underperform = 'U/P',
}

const WeightIcon = ({ weighting }: WeightIconProps): ReactElement | null => {
  const title = WeightingTitleType[weighting.toLowerCase()];

  if (!WeightingType[weighting]) {
    return null;
  }

  return (
    <div className={cx('body', weighting.toLowerCase())} data-testid="company-item-icon">
      <span>{title}</span>
    </div>
  );
};

export default WeightIcon;
